import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from '../shared-components/ng-login/auth/auth.service';
import { Roles } from '../utils/enums';

@Injectable()
export class AdminGuard implements CanActivate {
  /**
   * Constructor
   * @param router
   * @param authService
   */
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): boolean {
    if (!this.authService.getUserData().roles.includes(Roles.ADMIN)) {
      this.router.navigate(['dashboard']);
    }

    return this.authService.getUserData().roles.includes(Roles.ADMIN);
  }
}
